import { action } from 'satcheljs';
import type SearchResultItem from '../schema/SearchResultItem';
import type { SearchFilterOption } from '../schema/FilterOption';
import type { ObservableMap } from 'mobx';

export interface AssetSearchRequest {
    queryString: string;
    includesPeopleSuggestion?: boolean;
    filters: ObservableMap<string, SearchFilterOption> | null;
}

export interface AssetSearchResponse {
    assetType: string;
    results: SearchResultItem[];
    searchTerms?: string[];
}

/**
 * Sends the search for a specific asset type. If type is undefined, will search all registered assets
 */
export const invokeAssetSearch = action(
    'invokeAssetSearch',
    (searchRequest: AssetSearchRequest, assetType?: string) => ({
        searchRequest,
        assetType,
    })
);

/**
 * Public action for consumers to bind to for when asset searches start for a specific asset type. Will always fire once per search per asset type. For each
 * onAssetSearchStarted, there will be 1 or more onAssetSearchCompleted.
 */
export const onAssetSearchStarted = action(
    'onAssetSearchStarted',
    (searchRequest: AssetSearchRequest, assetType?: string) => ({
        searchRequest,
        assetType,
    })
);

/**
 * Triggers an action indicating search query is complete, so the results can be processed.
 * This will fire for the given searchable asset, and may fire multiple times if there are
 * multiple calls necessary to fetch all the data.
 */
export const assetSearchCompleted = action(
    'assetSearchCompleted',
    (searchResponse?: AssetSearchResponse, error?: string, searchRequest?: AssetSearchRequest) => ({
        searchResponse,
        error,
        searchRequest,
    })
);
